import { useEffect, useRef, useState } from "react";

export const Features = () => {
  const [isVisible, setIsVisible] = useState(false);
  const featuresRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (featuresRef.current) {
      observer.observe(featuresRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  const features = [
    {
      title: "Transmettre",
      description: "Faire redécouvrir aux jeunes générations l'importance des valeurs et **des réalisations de la République. Leur donner les outils pour en être à leur tour les artisans."
    },
    {
      title: "Renforcer",
      description: "Nous plaidons pour une extension de la Charte des droits et des devoirs du citoyen français à l'ensemble des citoyens, nés ou devenus Français ainsi qu'à une évolution de sa portée dans notre vie civique afin que chacun."
    },
    {
      title: "Protéger",
      description: "Nous sommes déterminés à mener des actions en justice contre ceux qui, par calcul ou par négligence, s'attaquent aux fondements de la République, qu'ils soient élus ou citoyens, institutions ou groupes d'influence."
    }
  ];

  return (
    <section className="pt-2 pb-12 bg-gradient-to-b from-[#F5E84A] via-[#FFFD4C] to-[#F5E84A]">
      <div className="container px-4 md:px-6 max-w-6xl mx-auto space-y-6">
        {/* Pillars card */}
        <div className="bg-gray-200/80 backdrop-blur-sm rounded-2xl p-5 md:p-6 shadow-sm">
          <h2 className="text-lg md:text-xl font-bold text-[#1E3A8A] mb-5">
            Dès lors, notre mission repose sur trois piliers :
          </h2>

          <div ref={featuresRef} className="space-y-4">
            {features.map((feature, index) => (
              <div
                key={index}
                className={`bg-[#1E3A8A] rounded-xl p-5 shadow-md transition-all duration-500 ${
                  isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
                }`}
                style={{ transitionDelay: `${index * 200}ms` }}
              >
                <h3 className="text-white font-semibold text-base mb-1">
                  {feature.title}
                </h3>
                <p className="text-white/90 text-sm leading-snug">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Engagement citoyen card */}
        <div className="bg-gray-200/80 backdrop-blur-sm rounded-2xl p-5 md:p-6 shadow-sm text-[#1E3A8A] [&_*]:text-[#1E3A8A] leading-snug text-[14px] space-y-3">
          <p className="font-semibold">Un engagement citoyen</p>
          <p className="text-justify">
            Profondément laïques, nous ne sommes ni un parti politique, ni une force d'opposition.
          </p>
          <p className="text-justify">
            Nous sommes une force de proposition pour un projet collectif contre la fragmentation de notre République car elle n'est pas un acquis : elle est une exigence. Une exigence de vérité, de courage et de transmission que, pour notre part, nous vivons comme une chance.
          </p>
          <p className="text-justify">
            Nous, Enfants de la République, avons choisi de relever ce défi et de porter ce flambeau afin de le transmettre intact dans son esprit à nos propres enfants en rappelant qu'être citoyen ne consiste pas seulement à revendiquer des droits mais aussi à accepter des devoirs.
          </p>
        </div>
      </div>
    </section>
  );
};
